// @ts-nocheck
import { IconFileText, IconClock, IconCoins } from '@tabler/icons-react';
import Time from '@/utils/time';
import Helper from '@/utils/helper';
import styles from './CustomerZoneHome.module.css';
import { invoiceStatusDisplay, MiniCard, MiniRow } from './CustomerZoneShared';

interface Props {
  invoices: any[];
  currencySymbol: string;
  base: string;
  nav: (path: string) => void;
  limit?: number;
}

export default function CustomerZoneInvoicesTab({ invoices, currencySymbol, base, nav, limit }: Props) {
  if (!invoices.length) return <p className={styles.emptyNote}>There are no invoices</p>;

  const items = limit ? invoices.slice(0, limit) : invoices;
  return items.map((inv, i) => {
    const { label, tone } = invoiceStatusDisplay(inv.InvoiceStatus);
    return (
      <MiniCard
        key={i}
        href={`/customerzone/viewinvoice${base}&i=${inv.ID}`}
        title={inv.InvoiceNumber}
        tone={tone}
        statusText={label}
        onClick={() => nav(`/customerzone/viewinvoice${base}&i=${inv.ID}`)}
        rows={<>
          {inv.ItemReference && (
            <MiniRow icon={<IconFileText />}>Ref {inv.ItemReference}</MiniRow>
          )}
          {inv.DueDate && (
            <MiniRow icon={<IconClock />}>
              {Time.toISOString(Time.parseDate(inv.DueDate), false, false)}
            </MiniRow>
          )}
          <MiniRow icon={<IconCoins />}>
            <b>{Helper.getCurrencyValue(inv.TotalInclusive, currencySymbol)}</b>
          </MiniRow>
        </>}
      />
    );
  });
}
